import {
    addAircraftType,
    confirm,
    deleteAircraftType,
    deleteFile,
    downloadFile,
    downloadFile2,
    editAircraftType,
    editApplicationNotes,
    generateCCR,
    override,
    revokeConfirmation,
    selectRole,
    summariseFlightTestCrew,
    summaryLoadingFlags,
    updateContactDetails,
    updateContactEmergencyDetails,
    updateLicenceInformation,
    updateRoleExperience,
    updateTestFlightExperience,
    updateTraining,
    uploadFile,
    uploadFile2,
    viewCatOneRequirements
} from "./actions";

import { getPermissionsForType } from "./permissions";

const escapeHtml = value => String(value || "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");

export const uploadedFiles = {
    "label": "Supporting Documents & Files",
    "description": "Upload any supporting documents or files here. Example: <strong>CV, Certificates, Licenses</strong>. <br/> These will be stored securely and will only be accessible to the Flight Test Crew team.",
    "key": "Files",
    "local": true,
    "headers": [{
        "headerName": "File",
        "field": "File"
    }],
    "actions": [{
        "label": "Upload File",
        "action": uploadFile
    }],
    "rowActions": [{
        "label": "Download",
        "action": downloadFile
    }, {
        "label": "Delete",
        "action": deleteFile
    }]
};

export const emergencyContact = {
    "label": "Emergency Contact",
    "key": "emCon",
    "field": true,
    "fields": [{
        "label": "Name",
        compute({ pageItem }) {
            return `${pageItem?.EmergencyContact?.FirstName || ""} ${pageItem?.EmergencyContact?.LastName || ""}`
        }
    }, {
        "label": "Phone Number",
        "key": "EmergencyContact.Phone"
    }, {
        "label": "Phone Number 2",
        "key": "EmergencyContact.Phone2"
    }, {
        "label": "Relation",
        "key": "EmergencyContact.Relation"
    }],
    "actions": [{
        "label": "Update Emergency Contact Details",
        "action": updateContactEmergencyDetails
    }],
    warn({ pageItem }) {
        let warnText = "";
        if (!pageItem?.EmergencyContact?.FirstName || !pageItem?.EmergencyContact?.LastName) {
            warnText += "Emergency contact name is missing.\n";
        }
        if (!pageItem?.EmergencyContact?.Phone) {
            warnText += "Emergency contact phone number is missing.\n";
        }
        if (!pageItem?.EmergencyContact?.Relation) {
            warnText += "Emergency contact relation is missing.\n";
        }

        return [warnText !== "", warnText];
    }
};

export const uploadedFiles2 = {
    "label": "Uploaded Files",
    "key": "Files",
    "local": true,
    "headers": [{
        "headerName": "File",
        "field": "File"
    }],
    "actions": [{
        "label": "Upload File",
        "action": uploadFile2
    }],
    "rowActions": [{
        "label": "Download",
        "action": downloadFile2
    }]
};

export const generatedFiles = {
    "label": "Documents",
    "key": "generatedFiles",
    "field": true,
    "fields": [{
        "label": "CCR",
        "key": "CCR"
    }, {
        "label": "FTA",
        "key": "FTA"
    }],
    "actions": [{
        "label": "Generate CCR",
        "action": generateCCR,
        show({ pageItem, store }) {
            if(store.state.appConfig.appPrefix !== "test") {
                return [false, "CCR generation is only available in the test environment"];
            }
            if (!pageItem?.Approved) {
                return [false, "Application is not approved"];
            }
            return [!!pageItem?.raw.CCRID, "No CCR is linked to this application"];
        }
    }
    // {
    //     "label": "Download FTA",
    //     async action({ db, pageItem }) {
    //         let url = await db.download(`Database/Documents/FTAs/${pageItem?.FTA}.docx`);
    //         window.open(url, "__blank");
    //     },
    //     show({ pageItem }) {
    //         return [pageItem?.FTA !== "Not Applicable", "No FTA Found"]
    //     }
    // }
    ]
}

export const licenceAndRatings = {
    "label": "Licences & Ratings",
    "key": "liceneAndRatings",
    "field": true,
    "fields": [{
        "label": "Pilots / LFTE Licence Number",
        "key": "Licence"
    }, {
        "label": "Medical Certificate Number",
        "key": "MedicalNumber"
    }, {
        "label": "Class of Medical Certificate",
        "key": "MedicalClass"
    }, {
        "label": "Medical Certificate Expiry Date",
        "key": "MedicalExpiry",
        "type": "date"
    }, {
        "label": "Flight Test Rating (Aeroplane)",
        "key": "raw.Ratings.AeroplaneCategory",
        show({ pageItem }) {
            return pageItem?.raw?.Role === "Pilot";
        }
    }, {
        "label": "Flight Test Rating (Helicopter)",
        "key": "raw.Ratings.HelicopterCategory",
        show({ pageItem }) {
            return pageItem?.raw?.Role === "Pilot";
        }
    }, {
        "label": "Licences",
        "class": "md:col-span-3",
        compute({ pageItem }) {
            return typeof pageItem?.raw?.Licences === "string" ? pageItem?.raw?.Licences : Object.values(pageItem?.raw?.Licences || {}).join(", ") || "None";
        },
        show({ pageItem }) {
            return pageItem?.raw?.Role === "Pilot";
        }
    }, {
        "label": "Other Ratings",
        "class": "md:col-span-3",
        compute({ pageItem }) {
            //if ratings other is not an array, make it an array and return the values joined by a comma, if it is an array, return the values joined by a comma, if it is not an array or string, return "None"
            const ratingsOther = pageItem?.raw?.Ratings?.Others;
            if (!Array.isArray(ratingsOther)) {
                return typeof ratingsOther === "string" ? ratingsOther : "None";
            }
            return ratingsOther.map(i => i.split("_").join(" ")).join(", ") || "None";
        },
        show({ pageItem }) {
            return pageItem?.raw?.Role === "Pilot";
        }
    }],
    "actions": [{
        "label": "Update Licence Information",
        "action": updateLicenceInformation
    }],
    show({ pageItem }) {
        return pageItem && (pageItem?.Role == "Pilot" || pageItem?.Role == "Lead Flight Test Engineer");
    },
    warn({ pageItem }) {
        let warnText = "";
        
        if(pageItem?.raw?.Role !== "Pilot" && pageItem?.raw?.Role !== "Lead Flight Test Engineer") {
            return [false, ""];
        }

        if (!pageItem?.Licence) {
            warnText += "Licence number is missing.\n";
        }
        if (!pageItem?.MedicalNumber) {
            warnText += "Medical certificate number is missing.\n";
        }
        if (!pageItem?.MedicalClass) {
            warnText += "Medical certificate class is missing.\n";
        }
        if (!pageItem?.MedicalExpiry) {
            warnText += "Medical certificate expiry date is missing.\n";
        }
        return [warnText !== "", warnText];
    }
}

export const flightHours = {
    "label": "Flight Hours & Test Experience",
    "key": "raw.NewFlightHours",
    "local": true,
    "fields": [{
        "label": "Has flight test experience in the last 90 days",
        "key": "raw.HasExperienceInLast90Days",
        "type": "boolean"
    }, {
        "label": "Last 90 Days Experience Details",
        "key": "raw.Last90DaysExperienceDetails",
        "class": "md:col-span-3",
        "grow": true,
        show({ pageItem }) {
            return pageItem?.raw?.HasExperienceInLast90Days === "Yes";
        }
    }],
    "headers": [{
        "headerName": "CS Type",
        "field": "CS"
    }, {
        "headerName": "Aircraft Type",
        "field": "Type"
    }, {
        "headerName": "Total Flight Hours",
        "field": "Hours"
    }, {
        "headerName": "Total Test Hours",
        "field": "Test"
    }, {
        "headerName": "Total PIC Hours (Last 12 Months)",
        "field": "FlightHoursPIC"
    }, {
        "headerName": "Total CO Hours (Last 12 Months)",
        "field": "FlightHoursCO"
    }, {
        "headerName": "Total PIC Test Hours (Last 12 Months)",
        "field": "FlightHoursPICTest"
    }, {
        "headerName": "Total CO Test Hours (Last 12 Months)",
        "field": "FlightHoursCOTest"
    }, {
        "headerName": "Last Updated",
        "field": "LastUpdated",
        "type": "timeDistance"
    }],
    "actions": [{
        "label": "Update Flight Test Experience",
        "action": updateTestFlightExperience
    }, {
        "label": "Add Aircraft Type",
        "action": addAircraftType
    }],
    "rowActions": [{
        "label": "Edit",
        "action": editAircraftType
    }, {
        "label": "Delete",
        "action": deleteAircraftType
    }
    ],
    warn(x) {
        let pageItem = x.pageItem;
        if (!(pageItem && (pageItem?.Role == "Pilot" || pageItem?.Role == "Lead Flight Test Engineer"))) {
            return "";
        }

        const items = Object.values(x.pageItem?.raw?.NewFlightHours || {});
        let warnText = "";
        if (!items || items.length === 0) {
            warnText += "No flight hours have been entered.\n";
        }

        for (const item of items) {

            let total = parseFloat(item.Hours);

            let last12Total =
                parseFloat(item.FlightHoursPIC) +
                parseFloat(item.FlightHoursCO) +
                parseFloat(item.FlightHoursPICTest) +
                parseFloat(item.FlightHoursCOTest);

            if (item.Test > total) {
                warnText += `The total test hours for ${item.Type} is greater than the total flight hours.\n`;
            };

            if (last12Total > total) {
                warnText += `The total PIC and CO hours for ${item.Type} is greater than the total flight hours.\n`;
            };
        };

        return [warnText !== "", warnText];
    },
    show({ pageItem }) {
        return pageItem && (pageItem?.Role == "Pilot" || pageItem?.Role == "Lead Flight Test Engineer");
    }
};

export const notes = {
    "label": "Notes",
    "key": "",
    "field": true,
    "fields": [{
        "label": "Notes",
        "key": "raw.Notes",
        "grow": true,
        "class": "md:col-span-3"
    }],
    "actions": [{
        "label": "Edit Notes",
        "action": editApplicationNotes
    }]
}

function formatPermissionText({ cat1, cat2, cat4 }) {
    return `Cat 1: ${cat1} <br> Cat 2: ${cat2} <br> Cat 4: ${cat4}`;
}

export const flightTestPermissions = {
    "label": "Flight Test Permissions",
    "key": "flightTestPerm",
    "field": true,

    "fields": [{
        "label": "CS-23 Test Flight Permissions",
        "grow": true,
        compute({ item }) {
            return formatPermissionText(getPermissionsForType(item, "CS-23"));
        }
    }, {
        "label": "CS-23P Test Flight Permissions",
        // "class": "md:col-span-3",
        "grow": true,
        compute({ item }) {
            return formatPermissionText(getPermissionsForType(item, "CS-23P"));
        }
    }, {
        "label": "CS-25 Test Flight Permissions",
        // "class": "md:col-span-3",
        "grow": true,
        compute({ item }) {
            return formatPermissionText(getPermissionsForType(item, "CS-25"));
        }
    }, {
        "label": "CS-27 Test Flight Permissions",
        // "class": "md:col-span-3",
        "grow": true,
        compute({ item }) {
            return formatPermissionText(getPermissionsForType(item, "CS-27"));
        }
    }, {
        "label": "CS-29 Test Flight Permissions",
        // "class": "md:col-span-3",
        "grow": true,
        compute({ item }) {
            return formatPermissionText(getPermissionsForType(item, "CS-29"));
        }
    }],
    //     "label": "Cat One - CS23",
    //     compute({ item }) {
    //         return best(item?.TestFlightPermissions?.CategoryOne.CS23)
    //     }
    // }, {
    //     "label": "Cat Two - CS23",
    //     compute({ item }) {
    //         return best(item?.TestFlightPermissions?.CategoryTwo.CS23)
    //     }
    // }, {
    //     "label": "Cat Four - CS23",
    //     compute({ item }) {
    //         return best(item?.TestFlightPermissions?.CategoryFour.CS23)
    //     }
    // }, {
    //     "label": "Cat One - CS23P",
    //     compute({ item }) {
    //         return best(item?.TestFlightPermissions?.CategoryOne.CS23P)
    //     }
    // }, {
    //     "label": "Cat Two - CS23P",
    //     compute({ item }) {
    //         return best(item?.TestFlightPermissions?.CategoryTwo.CS23P)
    //     }
    // }, {
    //     "label": "Cat Four - CS23P",
    //     compute({ item }) {
    //         return best(item?.TestFlightPermissions?.CategoryFour.CS23P)
    //     }
    // }, {
    //     "label": "Cat One - CS25",
    //     compute({ item }) {
    //         return best(item?.TestFlightPermissions?.CategoryOne.CS25)
    //     }
    // }, {
    //     "label": "Cat Two - CS25",
    //     compute({ item }) {
    //         return best(item?.TestFlightPermissions?.CategoryTwo.CS25)
    //     }
    // }, {
    //     "label": "Cat Four - CS25",
    //     compute({ item }) {
    //         return best(item?.TestFlightPermissions?.CategoryFour.CS25)
    //     }
    // }, {
    //     "label": "Cat One - CS27",
    //     compute({ item }) {
    //         return best(item?.TestFlightPermissions?.CategoryOne.CS27)
    //     }
    // }, {
    //     "label": "Cat Two - CS27",
    //     compute({ item }) {
    //         return best(item?.TestFlightPermissions?.CategoryTwo.CS27)
    //     }
    // }, {
    //     "label": "Cat Four - CS27",
    //     compute({ item }) {
    //         return best(item?.TestFlightPermissions?.CategoryFour.CS27)
    //     }
    // }, {
    //     "label": "Cat One - CS29",
    //     compute({ item }) {
    //         return best(item?.TestFlightPermissions?.CategoryOne.CS29)
    //     }
    // }, {
    //     "label": "Cat Two - CS29",
    //     compute({ item }) {
    //         return best(item?.TestFlightPermissions?.CategoryTwo.CS29)
    //     }
    // }, {
    //     "label": "Cat Four - CS29",
    //     compute({ item }) {
    //         return best(item?.TestFlightPermissions?.CategoryFour.CS29)
    //     }
    // }, {
    //     "label": "Override Reasons",
    //     "class": "md:col-span-3",
    //     "grow": true,
    //     "key": "OverrideInfo"
    // }],
    "actions": [{
        "label": "View Requirements",
        "action": viewCatOneRequirements
    }, { "label": "Set Override", "action": override }],
    show({ pageItem }) {
        return pageItem && pageItem?.Role == "Pilot";
    }
}

// ============================================
// NEW SECTIONS FROM FLIGHT-TEST-CREW INTEGRATION
// ============================================

export const confirmation = {
    "label": "Confirmation",
    "key": "confirmation",
    "field": true,
    "fields": [{
        "label": "Completed",
        compute({ pageItem }) {
            return pageItem?.Completed ? "Yes" : "No";
        }
    }, {
        "label": "Consent Given",
        compute({ pageItem }) {
            return pageItem?.Consent ? "Yes" : "No";
        }
    }, {
        "label": "Confirmation Date",
        "key": "Date.Confirmation",
        "type": "date"
    }],
    "actions": [{
        "label": "Confirm",
        "action": confirm,
        show({ pageItem, attachedItems }) {
            const warnings = Object
                .values(attachedItems)
 
                .filter(ai => ai.warn[0])
                .map(ai => `${ai.label}<br>${ai.warn[1]}`)
                .join("<br>");
                
            if (warnings.length > 0) return [false, warnings];
            else
                return [!pageItem?.Completed, "Already Confirmed"];
        },
    }, {
        "label": "Revoke Confirmation",
        "action": revokeConfirmation,
        show({ pageItem }) {
            return [pageItem?.Completed, "Not Confirmed"];
        }
    }]
};

export const contactDetails = {
    "label": "Contact Details",
    "key": "contactDetails",
    "field": true,
    "fields": [{
        "label": "Name",
        compute({ pageItem }) {
            return `${pageItem?.raw?.User?.FirstName} ${pageItem?.raw?.User?.LastName}`;
        }
    }, {
        "label": "Phone",
        "key": "raw.User.Phone"
    }, {
        "label": "Date of Birth",
        "key": "raw.User.DateOfBirth",
        "type": "date"
    }],
    "actions": [{
        "label": "Update Contact Details",
        "action": updateContactDetails
    }, {
        "label": "Select Role",
        "action": selectRole
    }],
    warn({ pageItem }) {
        let warnText = "";
        if (!pageItem?.raw?.User?.FirstName || !pageItem?.raw?.User?.LastName) {
            warnText += "Name is missing.\n";
        }
        if (!pageItem?.raw?.User?.Phone) {
            warnText += "Phone number is missing.\n";
        }
        if (!pageItem?.raw?.User?.DateOfBirth) {
            warnText += "Date of birth is missing.\n";
        }
        return [warnText !== "", warnText];
    }
};

export const training = {
    "label": "Training & Experience",
    "description": "Update your training and experience details here. This information is used to determine your eligibility for flight test activities. Upload any supporting documents or files in the <strong>Supporting Documents & Files</strong> section.",
    "key": "training",
    "field": true,
    "fields": [
        {
            "label": "CRM Training",
            "type": "header",
            "break": true,
            "class": "md:col-span-3"
        }, {
            "label": "CRM Training Completed",
            compute({ pageItem }) {
                return pageItem?.CRM?.Completed === "true" ? "Yes" : "No";
            }
        }, {
            "label": "CRM Training Date",
            "key": "CRM.Date",
            "type": "date",
            "noDateMessage": "Not Completed"
        }, {
            "label": "LFTE Training",
            "type": "header",
            "break": true,
            "class": "md:col-span-3"
        }, {
            "label": "LFTE Training Completed",
            compute({ pageItem }) {
                return pageItem?.LFTE?.Completed === "true" ? "Yes" : "No";
            }
        }, {
            "label": "LFTE Training Date",
            "key": "LFTE.Date",
            "type": "date",
            "noDateMessage": "Not Completed"
        }, {
            "label": "LFTE Training Details",
            "key": "LFTE.Details",
            "class": "md:col-span-3",
        }, {
            "label": "Other Training and Experience",
            "type": "header",
            "break": true,
            "class": "md:col-span-3"
        }, {
            "label": "Other Training Details",
            "key": "OtherTraining",
            "class": "md:col-span-3",
        }, {
            "label": "Role Experience",
            "key": "RoleExperience",
            "grow": true,
            "class": "md:col-span-3"
        }],
    "actions": [{
        "label": "Update Training",
        "action": updateTraining
    }, {
        "label": "Update Role Experience",
        "action": updateRoleExperience
    }]
};

export const summary = {
    "label": "AI - Generated Summary",
    "key": "Summary",
    "local": true,
    "field": true,
    "fields": [{
        "label": "Summary",
        "class": "md:col-span-3",
        "grow": true,
        compute({ item }) {
            const isLoading = summaryLoadingFlags[item?.ID];
            const hasText = item?.Summary?.Text;
            
            if (isLoading) {
                return "";
            }
            
            if (!hasText) {
                return "No summary generated, you can generate this in the actions";
            }
            
            return escapeHtml(item?.Summary?.Text).replaceAll("\n", "<br>");
        },
        get loading() {
            return function({ item }) {
                return summaryLoadingFlags[item?.ID] || false;
            };
        }
    }, {
        "label": "Generated",
        "key": "Summary.Date.Created",
        "type": "date"
    }, {
        "label": "Model",
        "key": "Summary.Model"
    }, {
        "label": "Generated By",
        compute({ item }) {
            return escapeHtml(item?.Summary?.CreatedBy?.Email || item?.Summary?.CreatedBy?.UID || "Unknown user");
        }
    }],
    "actions": [{
        "label": "Generate Summary",
        "action": summariseFlightTestCrew,
        show({ store }) {
            return [
                store.state.user.Security?.FlightTest?.Reviewer === true,
                "Only reviewers can generate summaries"
            ];
        }
    }],
    "rowActions": [],
    // show({ store }){ 
    //     console.log("Show context for summary:", store);
    //     return store.state.appConfig.appPrefix === "test"
    // }
};
